import React from "react";
import { useEffect } from "react";
import { CaseStudiesHeroSection } from "@tennr/frontend/sections/CaseStudiesHeroSection";
import { CaseStudiesCarouselSection } from "@tennr/frontend/sections/CaseStudiesCarouselSection";
import { CaseStudiesTestimonialSection } from "@tennr/frontend/sections/CaseStudiesTestimonialSection";
import { PageBackground } from "@tennr/frontend/components/PageBackground";
import { SiteFooter } from "@tennr/frontend/components/SiteFooter";
import { useLoaderData } from "@tanstack/react-router";
import { MetadataTags } from "@tennr/frontend/components/MetadataTags";
import "@tennr/style/index.css";
import "./CaseStudiesPage.css";

const bgImage = "/img/customer-stories-hero-bg.jpg";
const bgImageVert = "/img/customer-stories-hero-bg-vert.jpg";

export const CaseStudiesPage: React.FC = () => {
  const { caseStudies } = useLoaderData({ from: "/_app/customer-stories" });

  useEffect(() => {
    const preload = (src?: string) => {
      if (!src) return;
      const img = new Image();
      img.src = src;
    };

    const isMobile = window.innerWidth <= 768 || window.matchMedia("(orientation: portrait)").matches;

    if (isMobile) {
      // Preload vertical/mobile images
      preload("/img/homepage-hero-bg-vert2.jpg");
      preload("/img/product-hero-bg-vert2.jpg");
      preload("/img/customer-stories-hero-bg-vert.jpg");
      preload("/img/about-us-hero-bg-vert.jpg");
      preload("/img/case-study-hero-bg-vert.jpg");
      preload("/img/book-demo-hero-bg-vert.jpg");
    } else {
      // Preload desktop images
      preload("/img/homepage-hero-bg.jpg");
      preload("/img/product-hero-bg.jpg");
      preload("/img/customer-stories-hero-bg.jpg");
      preload("/img/about-us-hero-bg.jpg");
      preload("/img/case-study-hero-bg.jpg");
      preload("/img/book-demo-hero-bg.jpg");
    }

    preload("/img/grain.png"); // always used
  }, []);

  return (
    <>
      <MetadataTags
        title="Customer Stories | Tennr"
        description="Learn how Tennr helps customers. Read real-life case studies to find out how healthcare operators drive better outcomes with Tennr."
        imageUrl="https://tennr.com/share_cards/sharecard-stories.webp"
      />
      <main className="case-studies-page">
        <PageBackground bgImage={bgImage} bgImageVert={bgImageVert} />
        <CaseStudiesHeroSection />
        <CaseStudiesCarouselSection caseStudies={caseStudies} />
        <CaseStudiesTestimonialSection />
      </main>
      <SiteFooter bgImage="/img/footer-case-studies-bg.jpg" bgImageVert="/img/footer-case-studies-bg-vert.jpg" />
    </>
  );
};
